module.exports = __webpack_public_path__ + "static/img/BG-icon@2x.d99bfa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/login/BG-icon@2x.png
// module id = TRvK
// module chunks = 0